import { combineReducers } from 'redux';
import authReducer from './authReducer';
import projectReducer from './projectReducer';
import companyReducer from './companyReducer';
import appControlReducer from './appControlReducer';
import themeReducer from './themeReducer';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
import sketchControlReducer from './sketchControlReducer';
import notificationReducer from './notificationReducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import accessLevelReducer from './accessLevelReducer';
import floorReducer from './floorReducer';
import markerReducer from './markerReducer';
import datastoreReducer from './datastoreReducer';
import paymentReducer from './paymentReducer';
import commonsReducer from './commonsReducer';
import customerServiceReducer from './customerServiceReducer';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['project', 'floor', 'datastore']
}

const mainReducer = combineReducers({
    // APP CONTROL AN AUTH
    appControl: appControlReducer,
    auth: authReducer,

    // FIREBASE
    firebase: firebaseReducer,
    firestore: firestoreReducer,

    // THEME
    theme: themeReducer,

    // COMPANY, PROJECT, FLOOR, SKETCH, MARKER
    company: companyReducer,
    project: projectReducer,
    floor: floorReducer,
    sketch: sketchControlReducer,
    marker: markerReducer,

    ////////////////////////////////////////////////
    // NOTIFICATION UTILS
    notifUtils: notificationReducer,

    // ACCESS LEVEL UTILS
    alu: accessLevelReducer,

    ////////////////////////////////////////////////
    // DATASTORE TO CACHE DATA (SPECIFICALLY DESIGNED FOR REPORTS)
    datastore: datastoreReducer,
    commons: commonsReducer,

    // PAYMENT REDUCER
    payment: paymentReducer,

    // CUSTOMER SERVICE
    customerService: customerServiceReducer,
})

export default persistReducer(persistConfig, mainReducer);